import React from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from '@mui/material'
import StatusCard from '../../../../components/Cards/StatusCard'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'

import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact'
import { useNavigate } from 'react-router-dom'
import KanbanTab from '../../../../components/Kanban/KanbanTab'
import Sales from '../Sales'

const TopButton = ({ color, icon, onClick, text }) => (
  <Button
    color={color ?? primary}
    startIcon={icon}
    variant="outlined"
    fullWidth
    onClick={onClick}
    sx={{ backgroundColor: 'white' }}
  >
    {text}
  </Button>
)

const ProposalsDashboard = () => {
  const navigate = useNavigate()
  return (
    <Stack gap={1}>
      <Stack gap={1} direction={{xs: 'column', lg: 'row'}} justifyContent="space-between" alignItems='center'>
        <Typography variant="title2">Sales & Proposals</Typography>
        <Stack direction="row" gap={1}>
          <TopButton
            color="anBlue"
            icon={<RequestQuoteIcon />}
            text="New Quote"
            onClick={() => navigate('/clients/newquote')}
          />
          <TopButton
            color="anBlue"
            icon={<ConnectWithoutContactIcon />}
            text="New Client"
            onClick={() => navigate('/clients/new')}
          />
        </Stack>
      </Stack>
      <Sales />
    </Stack>
  )
}

export default ProposalsDashboard
